import { Component, OnInit } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-message-history',
  templateUrl: './message-history.component.html',
  styleUrls: ['./message-history.component.css']
})
export class MessageHistoryComponent implements OnInit {
  lastMessageHistory: any[] = []; // Initialize an empty array to store the data
  lastMessageHistoryLength: any = 1; // Initialize an empty array to store the data
  lastMessageHistoryLanguage: any

  constructor(private homeService: HomeService, public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
    console.log('response ---> data',);

    this.homeService.getLastMessageHistory().subscribe(
      (data) => {
        console.log('response ---> data', data.body);
        this.lastMessageHistory = data.body;  // Store the API response in the array
        if (this.lastMessageHistory.length < 1) {
          this.lastMessageHistoryLength = 0;
          this.homeService.setLastMessageHistoryLength(this.lastMessageHistoryLength)
        } else if(this.lastMessageHistory.length > 2) {
          this.lastMessageHistoryLength = data.body.length
          this.homeService.setLastMessageHistoryLength(this.lastMessageHistoryLength)
        }
      },
      (error) => {
        console.error('API Error:', error);  // Handle the error
      }
    );
    
  }

  timeAgo(timestamp: number, arabic: boolean): string {
    const now = new Date().getTime(); // Current time in milliseconds
    const diff = now - timestamp; // Difference between current time and provided timestamp

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (arabic) {
        if (days > 0) {
            return `منذ ${days} ${days > 1 ? 'أيام' : 'يوم'}`;
        } else if (hours > 0) {
            return `منذ ${hours} ساع${hours > 1 && hours < 11 ? 'ات' : 'ة'}`;
        } else if (minutes > 0) {
            return `منذ ${minutes} ${minutes > 1 && minutes < 11 ? 'دقائق' : 'دقيقة'}`;
        } else {
            return `منذ ${seconds} ${seconds > 1 && seconds < 11? 'ثواني' : 'ثانية'}`;
        }
    } else {
        if (days > 0) {
            return `${days} day${days > 1 ? 's' : ''} ago`;
        } else if (hours > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        } else if (minutes > 0) {
            return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        } else {
            return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
        }
    }
}

handleChatbotResponse(response : any){
  response = JSON.parse(response);
  response = JSON.parse(response);

  let finalResponse = response.messages[0].content;

  console.log('finalResponse ---> ', finalResponse)
// Extract JSON part
const jsonMatch = finalResponse.match(/<button>"(.*)"/);
if (jsonMatch && jsonMatch[1]) {
  const jsonString = jsonMatch[1].replace(/\\"/g, '"'); // Fix escaped quotes
  try {
    finalResponse = JSON.parse(jsonString);
    finalResponse = finalResponse.title 
    // Output: "Please tell me, which brand would you like to book a test drive for?"
  } catch (error) {
    console.error("Invalid JSON:", error);
  }
}

if (finalResponse) {
  finalResponse = finalResponse.replace(/<br\s*\/?>/g, '');
  finalResponse = finalResponse.replace(/<image\s*\/?>/g, '');
}

if (this.isArrayOfObjects(finalResponse)) {
  console.log('finalResponse ---> ', finalResponse);
  finalResponse = JSON.parse(finalResponse);
  return 'selected car details : ' + finalResponse[0].cardName;
}

  if(finalResponse && finalResponse.length >45 )
    return finalResponse.substring(0,42) + '...';


  return finalResponse;
}

isArrayOfObjects(jsonString: string): boolean {
  try {
    const parsed = JSON.parse(jsonString); // Parse JSON

    // Check if it's an array and every element is an object
    return Array.isArray(parsed) && parsed.every(item => typeof item === 'object' && item !== null);
  } catch (error) {
    return false; // Invalid JSON
  }
}




}
